<template>
<div class="page over">
    <Header title="传承师信息" />
    <div class="form-wrap">
        <div class="line">
            <p>代理商头像</p>
            <div class="avatar">
                <UploadAvatar class="upload" @callback="uploadCallback" />
                <img :src="infoData.agent_cover || Images.img_avatar_default" />
            </div>
        </div>
        <div class="line" @click="isShowCompany = true">
            <p>上级分公司</p>
            <van-field v-model="infoData.agent_branch" placeholder="请选择上级分公司" input-align="right" readonly :border="false" />
        </div>
        <div class="line">
            <p>公司名称</p>
            <van-field v-model="infoData.agent_company" placeholder="请输入公司名称" input-align="right" :border="false" />
        </div>
        <div class="line">
            <p>社会信用代码</p>
            <van-field v-model="infoData.agent_credit_code" placeholder="请输入社会信用代码" input-align="right" :border="false" />
        </div>
        <div class="line">
            <p>省市区</p>
            <van-field readonly clickable :value="infoData.area" input-align="right" :border="false" placeholder="点击选择省市区" @click="showArea = true" />
        </div>
    </div>
    <div class="btn" @click="onPressSubmit">立即{{isEdit > 0 ? '修改' : '提交'}}</div>
    <!-- 地区选择 -->
    <van-popup v-model="showArea" position="bottom">
        <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
    </van-popup>

    <van-action-sheet
        title="分公司列表"
        cancel-text="取消"
        close-on-click-action
        v-model="isShowCompany"
        :actions="company_list"
        @select="isSelectCompany"
        @cancel="isShowCompany = false"
    />

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import Header from "@/components/Header";
import UploadAvatar from "@/components/UploadAvatar";
import {
    areaList
} from '@vant/area-data';
export default {
    components: {
        Header: Header,
        UploadAvatar,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            loading: false,
            showArea: false,
            isShowCompany: false,
            areaList,
            uploader: [],
            isEdit: this.$route.query.isEdit || 0,
            infoData: this.$route.query.infoData || {
                agent_cover: "",
                agent_branch: "",
                company_id: "",
                agent_company: "",
                agent_credit_code: "",
                agent_province: "",
                agent_city: "",
                agent_area: "",
                area: "",
            },
            company_list: [],
        };
    },
    mounted() {
        this._requestDataSources();
    },
    methods: {

        // 图片选择回调
        uploadCallback(res) {
            console.log('res---->', res);
            this.infoData.agent_cover = res;
        },

        // 地区选择回调
        onConfirm(res) {
            this.infoData = {
                ...this.infoData,
                agent_province: res[0].name,
                agent_city: res[1].name,
                agent_area: res[2].name,
                area: res[0].name + res[1].name + res[2].name,
            }
            this.showArea = false
        },

        isSelectCompany(item) {
            console.log('item---->', item);
            this.infoData = {
                ...this.infoData,
                company_id: item.id,
                agent_branch: item.name
            }
        },

        async _requestDataSources() {
            let url = this.API.agent_company_all;
            let data = {};
            this.loading = true;
            const result = await this.$post(url, data);
            this.loading = false;
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.company_list = result.data;
            }
        },

        // 提交请求
        async onPressSubmit() {
            let url = this.API.agent_apply;
            let params = {
                token: this.Lockr.get("token"),
                ...this.infoData,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.$store.dispatch("UserInfo", true);
                this.Message({
                    title: result.msg,
                    onClose: () => {
                        this.$router.go(-1);
                    },
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    box-sizing: border-box;

    .form-wrap {
        padding: 0 1rem;
        overflow: hidden;
        background: #fff;
        margin: 1rem 1rem;
        border-radius: .5rem;

        .line {
            padding: 0 10px;
            height: 50px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px dashed #ddd;

            &:last-of-type {
                border: 0;
            }

            p {
                height: 50px;
                margin-right: 10px;
                font-size: 15px;
                color: #333;
                line-height: 50px;
            }

            .avatar {
                width: 40px;
                height: 40px;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                }

                .upload {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
            }

            span {
                font-size: 15px;
                color: #333;
            }

            .van-field {
                flex: 1;
                padding: 0;
                text-align: right;
            }
        }

        .line-textarea {
            margin: 5px 15px 0px;
            padding: 0 10px 10px;
            background: #fff;
            display: flex;
            flex-direction: column;

            p {
                height: 50px;
                margin-right: 10px;
                font-size: 15px;
                color: #333;
                line-height: 50px;
            }

            /deep/ textarea {
                flex: 1;
                box-sizing: border-box;
                border-width: 0px;
                resize: none;
                font-size: 15px;
                color: #333;
                text-align: justify;
            }
        }

    }

    .btn {
        margin: 50px 15px;
        height: 40px;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        border-radius: 3px;
        font-size: 15px;
        color: #fff;
        text-align: center;
        line-height: 40px;
    }
}
</style>
